import { apiPost } from '../api'

export const save_profile = data => {
  return apiPost({
    endpoint: 'user/save_profile',
    data: data
  })
}
